import React, { useEffect } from "react"
import { useInView } from "react-intersection-observer"
import { motion } from "framer-motion"
import { Link } from "gatsby"
import { HeaderLight } from "../components/header"
import { FooterLight } from "../components/footer"
import SEO from "../components/seo"
import "../css/index.css"

import placeholder1 from "../images/placeholder1.png"
import placeholder2 from "../images/placeholder2.jpg"

const IndexPage = () => {
  function onLinkClick() {
    document
      .getElementById("myHeader")
      .scrollIntoView({ block: "start", behavior: "smooth" })
  }

  useEffect(() => {
    const header = document.getElementById("myHeader")
    const sticky = header.offsetTop
    const scrollCallBack = window.addEventListener("scroll", () => {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky")
      } else {
        header.classList.remove("sticky")
      }
    })
    return () => {
      window.removeEventListener("scroll", scrollCallBack)
    }
  }, [])

  // InView hooks for animations on scroll view
  const [ref2, inView2] = useInView({
    triggerOnce: true,
    rootMargin: "400px 0px",
  })

  const [ref3, inView3] = useInView({
    triggerOnce: true,
    rootMargin: "-200px 0px",
  })

  const [ref4, inView4] = useInView({
    triggerOnce: true,
    rootMargin: "-200px 0px",
  })

  const [ref5, inView5] = useInView({
    triggerOnce: true,
    rootMargin: "-125px 0px",
  })

  const [ref6, inView6] = useInView({
    triggerOnce: true,
    rootMargin: "-125px 0px",
  })

  return (
    <div className="homepage">
      <SEO title="Home" />

      <section className="firstframe">
        <motion.svg
          initial={{ y: -200, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, ease: [0.3, -0.05, 0.01, 0.9] }}
          className="home-headlogo"
          xmlns="http://www.w3.org/2000/svg"
          width="22.35rem"
          viewBox="0 0 487.95 114.01"
        >
          <title>Horizon Logotype</title>
          <path
            d="M184.62,47.46a1,1,0,0,1,1-1h32.69q11.31,0,18.71,7.24a23.9,23.9,0,0,1,7.4,17.75A25.14,25.14,0,0,1,243,80a22.6,22.6,0,0,1-3.37,6.42,30.26,30.26,0,0,1-4,4.19A14.68,14.68,0,0,1,232.22,93l-.49.27a1,1,0,0,0-.4,1.36l15,26.44a1,1,0,0,1-.87,1.49H230.31a1,1,0,0,1-.87-.52l-14.08-25.6a1,1,0,0,0-.87-.52H202a1,1,0,0,0-1,1v24.65a1,1,0,0,1-1,1H185.62a1,1,0,0,1-1-1Zm40.57,16.63a10.09,10.09,0,0,0-7.41-2.92H202a1,1,0,0,0-1,1V80.28a1,1,0,0,0,1,1h15.82a10.27,10.27,0,0,0,7.41-2.84,9.32,9.32,0,0,0,2.94-7A9.94,9.94,0,0,0,225.19,64.09Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M262.78,46.47h14.36a1,1,0,0,1,1,1v74.1a1,1,0,0,1-1,1H262.78a1,1,0,0,1-1-1V47.46A1,1,0,0,1,262.78,46.47Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M294.91,60.18V47.46a1,1,0,0,1,1-1H351a1,1,0,0,1,1,1V60.81a1,1,0,0,1-.23.63l-37,44.85a1,1,0,0,0,.76,1.62h36.59a1,1,0,0,1,1,1v12.66a1,1,0,0,1-1,1H294.25a1,1,0,0,1-1-1V108.27a1,1,0,0,1,.23-.63l37-44.85a1,1,0,0,0-.76-1.62H295.9A1,1,0,0,1,294.91,60.18Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M373.69,56.5q12-11.62,29.34-11.62T432.37,56.5a37.65,37.65,0,0,1,12,28,37.73,37.73,0,0,1-12,28Q420.4,124.2,403,124.2t-29.34-11.65a37.7,37.7,0,0,1-12-28A37.62,37.62,0,0,1,373.69,56.5Zm12,45.79a24.42,24.42,0,0,0,34.65,0,24.31,24.31,0,0,0,7.11-17.75,24.39,24.39,0,0,0-7.11-17.77,24.33,24.33,0,0,0-34.65,0,24.39,24.39,0,0,0-7.11,17.77A24.31,24.31,0,0,0,385.7,102.29Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M527.44,47.46v74.1a1,1,0,0,1-1,1H513.81a1,1,0,0,1-.78-.39L477.65,76.51a1,1,0,0,0-1.78.61v44.44a1,1,0,0,1-1,1H460.52a1,1,0,0,1-1-1V47.46a1,1,0,0,1,1-1h12.69a1,1,0,0,1,.78.39l35.39,45.7a1,1,0,0,0,1.77-.6V47.46a1,1,0,0,1,1-1h14.31A1,1,0,0,1,527.44,47.46Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M104.11,139.41V29.67a2.14,2.14,0,0,1,4.27,0V139.41a2.14,2.14,0,0,1-4.27,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M113.26,120.05a2.33,2.33,0,0,1,.12-.73,2.15,2.15,0,0,1,2.74-1.28,35.67,35.67,0,1,0,0-67,2.14,2.14,0,0,1-1.46-4,39.93,39.93,0,1,1,0,75A2.15,2.15,0,0,1,113.26,120.05Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M113.26,108.08a2.13,2.13,0,0,1,3.15-1.87,24.69,24.69,0,1,0,0-43.35,2.13,2.13,0,1,1-2-3.74,29,29,0,1,1,0,50.84A2.14,2.14,0,0,1,113.26,108.08Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M95,96.73V72.35a2.14,2.14,0,1,1,4.27,0V96.73a2.14,2.14,0,1,1-4.27,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M85.82,113.8V55.28a2.14,2.14,0,1,1,4.27,0V113.8a2.14,2.14,0,1,1-4.27,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M76.68,119.9V49.18a2.13,2.13,0,1,1,4.26,0V119.9a2.13,2.13,0,0,1-4.26,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M67.53,106.49V62.59a2.14,2.14,0,0,1,4.27,0v43.9a2.14,2.14,0,0,1-4.27,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M58.39,90.64V78.44a2.13,2.13,0,0,1,4.26,0v12.2a2.13,2.13,0,1,1-4.26,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M49.24,110.14V58.93a2.14,2.14,0,0,1,4.27,0v51.21a2.14,2.14,0,1,1-4.27,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M39.49,86.06V83a2.14,2.14,0,0,1,4.27,0v3a2.14,2.14,0,1,1-4.27,0Z"
            transform="translate(-39.49 -27.54)"
          />
        </motion.svg>
        <motion.h2
          initial={{ x: "100%", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{
            delay: 0.85,
            duration: 2,
            ease: [0.3, -0.05, 0.01, 0.9],
          }}
          className="home-headslogan"
        >
          Striving to push designs to new Horizons
        </motion.h2>
        <svg
          id="scrollArrow"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
          onClick={onLinkClick}
          height="6vh"
          stroke="#282828"
          strokeWidth="5"
          strokeLinecap="round"
          fill="none"
        >
          <polyline points="20,40 50,70 80,40"></polyline>
          <polyline points="20,55 50,85 80,55"></polyline>
        </svg>
      </section>

      <header id="myHeader">
        <HeaderLight />
      </header>

      <motion.section
        ref={ref2}
        initial={{ y: "100%", opacity: 0 }}
        animate={inView2 ? { y: 0, opacity: 1 } : ""}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="secondframe"
      >
        <div>
          <h1>MAKING THE INVESTMENT IN YOUR TOOLS</h1>
          <p>
            Some of us, if not most, are constantly spending our time on our
            computers and on the internet; we spend that time interacting with
            tools like our keyboards and headphones. I believe in the idea that
            it is worth making the investment in the tools that we interact with
            on the daily basis to make the experience more refined; so I made my
            way towards designing mechanical keyboards to pursue my vision of an
            ideal keyboard.
            <br />
            <br />
            Truth to be told, the motivation to run my design projects is fueled on the
            idea that I can personalize and design them in the way I desire
            them to be. My hope for making my projects public is that I can appeal to
            other people who may share those ideals with me and appreciate
            them as I do.
          </p>
        </div>
      </motion.section>

      <motion.section
        ref={ref3}
        initial={{ x: "100%", opacity: 0 }}
        animate={inView3 ? { x: 0, opacity: 1 } : ""}
        transition={{ duration: 1, ease: "easeOut" }}
        className="thirdframe"
      >
        <div className="thirdcontainer">
          <img className="hyperionImage" alt="placeholder" src={placeholder1} />
          <div className="home-projecttext">
            <h2>Hyperion</h2>
            <h5>
              Currently On-Going Project : Finished third round of prototypes
            </h5>
            <p>
              My vision of an ideal keyboard materialized. Sleek modernized
              korean-custom keyboard aesthetics, easy to pick-up handles, and
              experimental mounting mechanism for greater typing experience and
              acoustics in a seamless design.
            </p>
            <div style={{ marginTop: "1.3rem" }}>
              <Link className="homelinks" to="/hyperion">
                Discover
              </Link>
            </div>
          </div>
        </div>
      </motion.section>

      <motion.section
        ref={ref4}
        initial={{ x: "-100%", opacity: 0 }}
        animate={inView4 ? { x: 0, opacity: 1 } : ""}
        transition={{ duration: 1, ease: "easeOut" }}
        className="fourthframe"
      >
        <div className="fourthcontainer">
          <div className="home-projecttext">
            <h2>Eliza</h2>
            <h5>Scrapped Design Project</h5>
            <p>
              An attempt on screwless design with inspirations drawn from iconic
              boards. Toblerone weight from Jane, stepped side handles from
              Hachi, and symmetrical WKL (Win-Key Less) blocker layout from
              Bauer; all in a screwless form.
            </p>
            <div style={{ marginTop: "1.3rem" }}>
              <Link className="homelinks" to="/eliza">
                Discover
              </Link>
            </div>
          </div>
          <img className="elizaImage" alt="placeholder" src={placeholder2} />
        </div>
      </motion.section>

      <section className="fifthframe">
        <motion.div
          ref={ref5}
          initial={{ x: "-100%", opacity: 0 }}
          animate={inView5 ? { x: 0, opacity: 1 } : ""}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <Link className="home-about" to="/about">
            <h2>ABOUT</h2>
            <p>Learn about Horizon Designs</p>
          </Link>
        </motion.div>

        <motion.div
          ref={ref6}
          initial={{ x: "100%", opacity: 0 }}
          animate={inView6 ? { x: 0, opacity: 1 } : ""}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <Link className="home-contact" to="/contact">
            <h2>CONTACT</h2>
            <p>Reach out to Horizon Designs</p>
          </Link>
        </motion.div>
      </section>
      <FooterLight />
    </div>
  )
}

export default IndexPage
